import {
  timelockEncrypt,
  timelockDecrypt,
  mainnetClient,
  roundAt,
  Buffer,
} from 'tlock-js';

let client: ReturnType<typeof mainnetClient> | null = null;

function getClient() {
  if (!client) client = mainnetClient();
  return client;
}

export async function getChainHash(): Promise<string> {
  const info = await getClient().chain().info();
  return info.hash;
}

export async function roundForUnlock(unlockUnix: number): Promise<number> {
  const info = await getClient().chain().info();
  return roundAt(unlockUnix * 1000, info);
}

export async function tlockWrapCek(cek: Uint8Array, round: number): Promise<string> {
  return timelockEncrypt(round, Buffer.from(cek), getClient());
}

export async function tlockUnwrapCek(ciphertext: string): Promise<Uint8Array> {
  const out = await timelockDecrypt(ciphertext, getClient());
  return new Uint8Array(out);
}
